import { useQueries } from '@tanstack/react-query';
import { fetchAccounts } from './apiFetchAccounts';
import { useEffect, useState } from 'react';
import { AccountOut } from '../../../../store/api';
import { globalErrorResponse } from '../../../../shared/notification/actions';

export const ACCOUNTS_QUERY = 'accounts';
const ACCOUNT_SUGGESTION_QUERY = 'accountSuggestion';

type FetchAccountSuggestionFunctionType = () => Promise<AccountOut>;

export const useAccounts = (fetchAccountSuggestion: FetchAccountSuggestionFunctionType) => {
    const [selectedAccount, setSelectedAccount] = useState<AccountOut>();
    const [accounts, suggestedAccount] = useQueries({
        queries: [
            {
                queryKey: [ACCOUNTS_QUERY],
                queryFn: fetchAccounts,
                onError: error => {
                    globalErrorResponse('Failed to fetch accounts', error);
                }
            },
            {
                // We use cache time 0 here because we don't want to cache the data as it can change frequently.
                queryKey: [ACCOUNT_SUGGESTION_QUERY],
                queryFn: fetchAccountSuggestion,
                cacheTime: 0
            }
        ]
    });
    const mainAccount = accounts.data?.find(account => account.type === 'MainAccount');

    useEffect(() => {
        setSelectedAccount(suggestedAccount.data ?? mainAccount);
    }, [mainAccount, suggestedAccount.data]);

    const onAccountChange = (account: AccountOut) => {
        setSelectedAccount(account);
    };

    return {
        ...accounts,
        selectedAccount,
        onAccountChange
    };
};
